import { copyableNotification as tdsCopyableNotification } from '@tencent/tds-ui';
import { MultiApp } from '@/config/context';
import { copyableNotification } from '@/presentation/components/copyable-notification';
import { ENV } from '../env-config';
import { getBusiMsg, getHttpMsg } from './code';

export interface IErrorInfo {
  /** http 错误状态码 */
  statusCode?: number;
  /** 业务错误码 */
  busiCode?: number;
  msg?: string;
  traceId?: string;
  url: string;
}

const IGNORE_ERROR_API = [
  '/v5/api/issue/classify/keys',
  '/v5/api/app/selector-data',
];

const notifacionProvider: Record<MultiApp, any> = {
  [MultiApp.WOA]: copyableNotification,
  [MultiApp.Internal]: copyableNotification,
  [MultiApp.Pro]: tdsCopyableNotification,
  [MultiApp.Sgp]: tdsCopyableNotification,
};

export const promptError = (info: IErrorInfo) => {
  const currentApp = process.env.APP_VERSION as MultiApp;
  const { busiCode, statusCode, msg, traceId, url } = info;
  let primaryText = '';
  let copyText = '';
  const secondaryText = traceId ? `traceId: ${traceId}` : '';

  // hardcode一下，海外版后台服务没部署，非要前端屏蔽错误
  if (IGNORE_ERROR_API.includes(url) && ENV.isGlobal) {
    return;
  }

  if (busiCode) {
    // 业务出错信息展示优先级：后台返回>本地映射
    primaryText = `code:${busiCode},msg:${msg || getBusiMsg(busiCode)}`;
    copyText = `api:${url}\nbusiCode:${busiCode}\ntraceId:${traceId}\nmsg:${msg}`;
  } else if (statusCode) {
    primaryText = `code:${statusCode},msg:${msg ?? getHttpMsg(statusCode)}`;
    copyText = `api:${url}\nstatusCode:${statusCode}\ntraceId:${traceId}\nmsg:${msg}`;
  }
  if (!primaryText) return;

  const notification = notifacionProvider[currentApp];

  notification.show({
    type: 'error',
    title: '请求出错',
    placement: 'topRight',
    primaryText,
    secondaryText,
    copyText,
  });
};
